export default __webpack_public_path__ + "d591ea172f983c0e05906dd7b4d19bd9.svg";